// Стиль слоя термических фронтов (линий максимального градиента температуры).
// Линия — ЖЁЛТАЯ с белой подложкой: отличается и от графитовой изотермы, и от
// красных изолиний волнения (все три можно включить разом, линии не путаются);
// читается над синим и над красным концом coolwarm. Подписи T — canvas-иконки по
// округлённому градусу (glyph-сервера у карты нет); плашка тёмная, чтобы жёлтый
// текст читался (на белой плашке жёлтый исчезал бы).

import { LABEL_PLATE_BG, mapColorOf } from '../brand/mapColors'
import { OVERLAY_PREFIX } from './layerOrder'

export const FRONT_PREFIX = OVERLAY_PREFIX + 'front-'

/** Цвет линии фронта — гаммы домена. См. `isothermLineColor` о том, почему функция. */
export function frontLineColor(): string {
  return mapColorOf('front')
}

/** Белая подложка — приём читаемости, общий на все бренды. */
export const FRONT_CASING_COLOR = '#ffffff'
export const FRONT_CASING_OPACITY = 0.6
/** Плашка подписи фронта — тёмная (жёлтый текст на ней читается). Общая на все
 *  бренды: это приём читаемости поверх чужой картинки, а не айдентика. */
export const FRONT_LABEL_BG = LABEL_PLATE_BG

const LINE_WIDTH = 1.6
const CASING_EXTRA = 2.2

export type FrontPart = 'line' | 'casing' | 'labels'

export function frontLayerId(key: string, part: FrontPart): string {
  return `${FRONT_PREFIX}${key}-${part}`
}

export function frontSourceId(key: string, which: 'line' | 'labels'): string {
  return `${FRONT_PREFIX}src-${which}-${key}`
}

/** id картинки подписи для градуса — под data-driven icon-image
 *  (`['concat','front-lbl-',['to-string',['get','temp']]]`). */
export function frontLabelImageId(temp: number): string {
  return `front-lbl-${temp}`
}

/** Ширина линии по зуму (тоньше на обзорных, заметнее на рабочих). */
export function frontWidthExpr(width: number) {
  return [
    'interpolate',
    ['linear'],
    ['zoom'],
    3,
    width * 0.75,
    7,
    width,
    12,
    width * 1.5,
  ]
}

export const frontLineWidthExpr = () => frontWidthExpr(LINE_WIDTH)
export const frontCasingWidthExpr = () => frontWidthExpr(LINE_WIDTH + CASING_EXTRA)
